import { AppPlatform } from 'modules/mobileApps/types';
import { useEffect, useRef, useState } from 'react';
import { BottomTooltip } from 'ui/tooltip';
import { Destination } from '../types';
import { InAppTooltipBreakdown } from './InAppTooltipBreakdown';
import { Bar, BarContainer } from './Styled';

export const ProgressBarWithTooltip = ({ data, total }: { data: Destination[]; total: number }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [barWidth, setBarWidth] = useState(0);
  const [barHeight, setBarHeight] = useState(0);

  // @ts-ignore
  useEffect(() => {
    if (containerRef?.current) {
      setBarWidth(containerRef?.current?.getBoundingClientRect()?.width || 0);
      setBarHeight(containerRef?.current?.getBoundingClientRect()?.height);
    }
  }, [containerRef.current]);
  return (
    <div>
      {/* @ts-ignore */}
      <BarContainer data-test="progress-bar-container" ref={containerRef}>
        {data.map(
          (
            {
              color,
              percentage,
              value,
              appName,
              platform,
            }: {
              color: string;
              percentage: number;
              value: number;
              appName: string;
              platform: AppPlatform;
            },
            idx: number,
          ) => (
            <BottomTooltip
              key={`${appName}-${idx}`}
              tooltipContent={
                <InAppTooltipBreakdown
                  destination={{
                    value,
                    appName,
                    platform,
                  }}
                  total={total}
                />
              }
            >
              <Bar
                color={color}
                style={{ width: barWidth * (percentage / 100), height: barHeight }}
                // @ts-ignore
                percentage={percentage}
              />
            </BottomTooltip>
          ),
        )}
      </BarContainer>
    </div>
  );
};
